<!-- @format -->

<div class="cdialog" style="width: 300px; height: 500px; max-height: 80vh">
  <div class="dialogHeader">
    <div mat-dialog-title *ngIf="!objectId">{{_common.space_facility_add}}</div>
    <div mat-dialog-title *ngIf="objectId">
      <div class="font-bold">{{object?.name}}</div>
    </div>
    <div class="spacer"></div>
    <div (click)="cancel()" class="closeButton">
      <fa-icon icon="times"></fa-icon>
    </div>
  </div>

  <mat-dialog-content class="max-height">
    <mat-tab-group>
      <mat-tab [label]="_common.space_facilities">
        <div class="max-scroll dialogBody">
          <form [formGroup]="form">
            <div class="card">
              <div class="cardBody space-y-2">
                <div>
                  <app-form-field class="w-full">
                    <app-label>{{_common.name}}</app-label>
                    <input matInput formControlName="name" required />
                  </app-form-field>
                </div>
                
                <!-- <ng-container *ngFor="let dlang of dlangs">
                  <div class="flex flex-col space-y-2">
                    <div>{{_common.langs??[dlang]??dlang}}</div>
    
                    <div [formGroup]="$any(form.controls['name_lang'])">
                      <app-form-field style="width: 100%" appearance="outline">
                        <app-label>Name</app-label>
                        <input matInput [formControlName]="dlang" />
                      </app-form-field>
                    </div>
                  </div>
                </ng-container> -->
              </div>
              <div class="cardDivider"></div>
              <div class="cardHeader">{{_common.Facility.pricing}}</div>
              <div class="cardBody space-y-2">
                <div>
                  <app-form-field class="w-full">
                    <mat-select formControlName="fee" (selectionChange)="updateForm()">
                      <mat-option [value]="fees.free">{{_common.Facility.free}}</mat-option>
                      <mat-option [value]="fees.fee">{{_common.Facility.fee}}</mat-option>
                      <mat-option [value]="fees.custom">{{_common.Facility.input}}</mat-option>
                    </mat-select>
                  </app-form-field>
                </div>
                <div *ngIf="form.value.fee==fees.custom">
                  <app-form-field class="w-full">
                    <span appPrefix>$&nbsp;</span>
                    <input matInput formControlName="feeText" required />
                  </app-form-field>
  
                </div>
              </div>
              
              <div class="cardDivider"></div>

              <div class="cardHeader">{{_common.images}}</div>
              <div class="cardBody space-y-2">
                <app-image-list [multiple]="false" [imageContainer]="container"></app-image-list>
              </div>
            </div>
          </form>
        </div>
      </mat-tab>

      <mat-tab label="{{_common.other_language}}">
        <div class="dialogBody max-scroll">
          <div *ngFor="let dlang of dlangs" class="card">
            <div class="cardBody flex flex-col space-y-2">
              <div class="lang-chip">
                {{_common[_common.langs??[dlang]??dlang]}}
              </div>

              <div [formGroup]="$any(form.controls['name_lang'])">
                <app-form-field style="width: 100%" appearance="outline">
                  <app-label>{{_common.space_name}}</app-label>
                  <input matInput [formControlName]="dlang" />
                </app-form-field>
              </div>

            </div>

          </div>

        </div>

      </mat-tab>
    </mat-tab-group>

  </mat-dialog-content>
  <div class="dialogBar">
    <button class="app-btn btn-outline" (click)="remove()" *ngIf="objectId">
      <fa-icon icon="trash" style="margin-right: 5px"></fa-icon>{{_common.delete}}
    </button>

    <div class="spacer"></div>

    <button class="app-btn" (click)="save()" color="primary">
      {{_common.save}}
    </button>
  </div>
</div>